import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { CircularProgress } from '@mui/material';
import { Box, Typography, Skeleton } from '@weave-mui/material';
export const Loading = ({ message = 'Loading...', size = 40 }) => {
    return (_jsxs(Box, { sx: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '50vh',
            gap: 2,
        }, children: [_jsx(CircularProgress, { size: size }), message && (_jsx(Typography, { variant: "body2", color: "text.secondary", children: message }))] }));
};
export const InlineLoading = ({ message, size = 20 }) => {
    return (_jsxs(Box, { sx: {
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            py: 1,
        }, children: [_jsx(CircularProgress, { size: size }), message && (_jsx(Typography, { variant: "body2", color: "text.secondary", children: message }))] }));
};
export const TableSkeleton = ({ rows = 5 }) => {
    return (_jsx(Box, { children: Array.from({ length: rows }).map((_, index) => (_jsx(Skeleton, { variant: "rectangular", height: 52, sx: { mb: 1 } }, index))) }));
};
export const CardSkeleton = () => {
    return (_jsxs(Box, { children: [_jsx(Skeleton, { variant: "text", width: "60%", height: 32, sx: { mb: 1 } }), _jsx(Skeleton, { variant: "rectangular", height: 118, sx: { mb: 1 } }), _jsx(Skeleton, { variant: "text", width: "40%" })] }));
};
export const ListSkeleton = ({ items = 3 }) => {
    return (_jsx(Box, { children: Array.from({ length: items }).map((_, index) => (_jsxs(Box, { sx: { display: 'flex', alignItems: 'center', mb: 2 }, children: [_jsx(Skeleton, { variant: "circular", width: 40, height: 40, sx: { mr: 2 } }), _jsxs(Box, { sx: { flex: 1 }, children: [_jsx(Skeleton, { variant: "text", width: "80%" }), _jsx(Skeleton, { variant: "text", width: "60%" })] })] }, index))) }));
};
export default Loading;
